import {IIni} from "../_interfaces/IIni";
import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";

export const IniNext = (rid: string) => {
    fetch(apiAddress + "/ini/next/" + rid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => console.log('IniNextresult ',data))
}

export const IniNewRound = (rid: string) => {
    fetch(apiAddress + "/ini/newround/" + rid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => console.log('IniNewRoundresult ',data))
}

export const IniAdd = (ini: IIni) => {
    fetch(apiAddress + "/ini/", createOptions('POST', ini))
        .then((res) => res.json())
        .then((data) => console.log('IniAddresult ',data))
}


export const IniClear = (rid:string) => {
    fetch(apiAddress + "/ini/clear/" + rid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => console.log('IniClearresult ',data))
}

export const IniUnset = (cid: string, rid: string) => {
    fetch(apiAddress + "/ini/unset/" + rid + '/' + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => console.log('IniUnSetresult ',data))
}

export const IniSet = (cid: string, rid: string) => {
    fetch(apiAddress + "/ini/set/" + rid + '/' + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => console.log('IniSetresult ',data))

}

export const IniWait = (cid: string, rid: string) => {
    fetch(apiAddress + "/ini/set/" + rid + '/' + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => console.log('IniWaitresult ',data))
}